var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{
    small: _vm.small,
    large: _vm.large,
    'x-large': _vm.xLarge,
    'flip-x': _vm.flipX,
    'flip-y': _vm.flipY,
    white: (_vm.color === 'white'),
    primary: (_vm.color === 'primary'),
    secondary: (_vm.color === 'secondary'),
  },attrs:{"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"},domProps:{"innerHTML":_vm._s(_vm.path)}})}
var staticRenderFns = []

export { render, staticRenderFns }